import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { SuperAdminGuard } from "../guards/super-admin.guard";

export const SuperAdminRoutes: Route[] = [
  {
    path: "super/dashboard",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-dashboard/super-dashboard.component").then(
        (mod) => mod.SuperDashboardComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: "super/institutes",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-institutes/super-institutes.component").then(
        (mod) => mod.SuperInstitutesComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: "super/users",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-users/super-users.component").then(
        (mod) => mod.SuperUsersComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  // 2026-05-06 #1 (Phase I) — I-3 audit log viewer + I-4 bulk
  // feature-flag flip. Backend endpoints (/super/audit-log,
  // /super/feature-flags/bulk) are pending — pages registered but
  // hidden in side-menu via BACKEND_GAP_ITEMS until then.
  {
    path: "super/audit-log",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-audit-log/super-audit-log.component").then(
        (mod) => mod.SuperAuditLogComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: "super/feature-flags",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-feature-flags/super-feature-flags.component").then(
        (mod) => mod.SuperFeatureFlagsComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  // I-1 — Tenant onboarding wizard. POSTs combined identity + admin
  // user + branding payload to /super/institutes (backend pending).
  // Hidden from side-menu via BACKEND_GAP_ITEMS until endpoint
  // accepts the new shape; super_admin can hit URL directly to test.
  {
    path: "super/onboarding",
    loadComponent: () =>
      import("../../Feature/super-admin/pages/super-onboarding/super-onboarding.component").then(
        (mod) => mod.SuperOnboardingComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
];
